import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";



export const PrinterOptionsSlice = createSlice({
  name: "PrinterOptionsSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    PrinterOptions: (state) => {
      state.isLoading = true;
    },
    successPrinterOptions: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePrinterOptions: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPrinterOptions: (state) => {
      state.data = {};
    },
  },
});

export const {
  PrinterOptions,
  successPrinterOptions,
  failurePrinterOptions,
  clearPrinterOptions,
} = PrinterOptionsSlice.actions;

export default PrinterOptionsSlice.reducer;
